import italianMessages from './it';
import englishMessages from './en';

const i18nMessages = {
    it: italianMessages,
    en: englishMessages,
};

export default i18nMessages;